module.exports = __webpack_public_path__ + "img/BAY.848a1be4.png";